// Gastrointestinal Disorders
const gastrointestinalDisorders = [
    "Irritable Bowel Syndrome (IBS)",
    "Crohn's Disease",
    "Ulcerative Colitis",
    "Gastroesophageal Reflux Disease (GERD)",
    "Celiac Disease",
    "Pancreatitis",
    "Gallstones",
    "Gallbladder Cancer",
    "Diverticulitis",
    "Gastritis",
    "Peptic Ulcers",
    "Hemorrhoids",
    "Hepatitis (Various Types)",
    "Liver Cirrhosis",
    "Primary Biliary Cirrhosis (PBC)",
    "Non-Alcoholic Fatty Liver Disease (NAFLD)",
    "Hemochromatosis",
    "Inflammatory Bowel Disease (IBD)",
    "Eosinophilic Esophagitis",
    "Gastroparesis",
    "Sclerosing Cholangitis",
    "Hereditary Hemorrhagic Telangiectasia (HHT)",
    "Chronic Pancreatitis",
    "Small Intestinal Bacterial Overgrowth (SIBO)",
    "Wilson Disease",
    "Zollinger-Ellison Syndrome",
    "Dumping Syndrome",
    "Esophageal Stricture",
    "Food Poisoning",
    "Giardiasis",
    "Appendicitis",
    "Biliary Atresia",
    "Intestinal Obstruction",
    "Malabsorption Syndrome",
    "Barrett's Esophagus",
    "Anal Fissure",
    "Reflux Esophagitis",
    "Lactose Intolerance",
    "Hirschsprung's Disease",
    "Gardner's Syndrome",
    "Whipple's Disease",
    "Esophageal Cancer",
    "Stomach Cancer",
    "Colorectal Polyps",
    "Familial Adenomatous Polyposis (FAP)",
    "Hereditary Nonpolyposis Colorectal Cancer (HNPCC)",
]

const gastro = gastrointestinalDisorders.reduce((accumulator, disease) => {
    accumulator.push({category: 'Gastrointestinal', disease})
    return accumulator
}, [])

export default gastro